export default class Missile extends Phaser.GameObjects.Image {
    public body: Phaser.Physics.Arcade.Body;
    private _speed: number;
    private _boundaryBottom: number; // bottom boundary
    private _x: number = 0;
    private _y: number = 0;
    private _centerY: number = 0;

    private _isFirstBatch: boolean = false;
    private _lane: any;

    public warning: Phaser.GameObjects.Sprite;
    private _warningInProgress: boolean = false;
    private _timeElapsed: number = 0;

    private _stopMissileCallback: Function;
    private _audio: Phaser.Sound.BaseSound;
    public tag: string;
    private _move: Function;

    constructor(scene: Phaser.Scene, x: number, y: number, key: string, frame: string) {
        super(scene, x, y, key, frame);
        this.tag = frame;
        // this.tag = key;
        scene.add.existing(this);
        this._boundaryBottom = window.constants.BASE_HEIGHT + this.height;
        this.setOrigin(0.5, 0.5);
        this._centerY = window.constants.BASE_HEIGHT / 2;
        this._audio = this.scene.sound.add("missile", {
            volume: window.constants["VOLUME"],
            loop: false
        })
        this._move = this._moveDown.bind(this);
        this._initPhysics();
        this.stop();
    }

    private _initPhysics(): void {
        // let offset = window.constants.DATA.colliderOffset[this.tag];
        this.scene.physics.world.enable(this);
        this.body.setAllowGravity(false);
        this.body.setAllowDrag(false);
        this.body.setAllowRotation(false);
        // let offset = window.constants.DATA.colliderOffset[this.tag];
        // this.body.setSize(this.width * offset.width, this.height * offset.height);
        // this.body.setOffset(this.width * offset.x, this.height * offset.y);
        this.body.setImmovable(true);
        this.body.moves = false;
        // this.setOrigin(offset.cx, offset.cy);

        let colliderData = window.constants.DATA.colliders[this.tag];
        this.body.setSize(colliderData.width, colliderData.height);
        this.body.setOffset(colliderData.x, colliderData.y);
        this.setOrigin(colliderData.pivotX, colliderData.pivotY);
    }

    private _moveOffScreen() {
        let x = window.constants.BASE_WIDTH + 100;
        let y = window.constants.BASE_HEIGHT + 600;
        this.setPosition(x, y);
        if (this.warning) {
            this.warning.setPosition(x, y);
        }
    }

    private _createWarningSprites() {
        this.warning = this.scene.add.sprite(this._x, this._y, "assets", 'warning_sheet_0');
        this._stopWarning();
    }

    private _startWarning() {
        this.warning.setPosition(this._x, this._centerY);
        this.warning.setVisible(true);
        this.warning.setActive(true);
        this.warning.play("warning_anim");
        this._warningInProgress = true;
    }

    private _stopWarning() {
        this._warningInProgress = false;
        if(this.warning) {
            this.warning.setVisible(false);
            this.warning.setActive(false);
        }
    }

    private _moveDown(time, dt) {
        this. y += this._speed * dt; 
    }

    private _startPhysics() {
        this.scene.physics.world.enable(this);
        this.body.setEnable(true);
        this.body.reset(this._x, this._y - (this.height / 2));
        // this.body.setVelocityY(this._speed);
    }

    private _stopPhysics() {
        this.scene.physics.world.disable(this);
        this.body.setEnable(false);
        this.body.stop();
    }

    private _startMissile() {
        this.setVisible(true);
        this.setActive(true);
        this._startPhysics();
        this._audio.play();
    }

    private _stopMissile() {
        this._audio.stop();
        this.setActive(false);
        this.setVisible(false);
        this._stopPhysics();
        this._moveOffScreen();
    }

    update(time, dt) {
        if(this.active) {
            this._timeElapsed += dt;
            if (this._warningInProgress) {
                if (this._timeElapsed > 1500) {
                    this._stopWarning();
                }
                else if (this._timeElapsed > 500 && !this.warning.active) {
                    this.warning.setVisible(true);
                    this.warning.setActive(true);
                }
            }
            else {
                if (this.visible) {
                    let delta = Math.floor(dt * 10) * 0.0001;
                    this._move(time, delta);
                    if (this.y > this._boundaryBottom) {
                        this.stop();
                    }
                }
                else {
                    this._startMissile();
                }
            }
        }
    }

    public setProperties(speed: number, lane: any, callback: Function) {
        let position = lane.position;
        this._lane = lane;
        this._speed = speed;
        this.setPosition(position.x, position.y);
        this._x = position.x;
        this._y = position.y;
        this._createWarningSprites();
        this._stopMissileCallback = callback;
    }

    public start(lane: any, firstBatch: boolean) {
        this.setActive(true);
        this._isFirstBatch = firstBatch;
        this._lane = lane;
        this._x = this._lane.position.x;
        this._y = this._lane.position.y;
        this._startWarning();
    }

    public stop() {
        this._stopWarning();
        this._stopMissile();
        if (this._lane) {
            this._lane.isReservedLane = false;
        }
        if (this._stopMissileCallback) {
            this._stopMissileCallback(this._isFirstBatch);
        }
        this._timeElapsed = 0;
    }

    public hit() {

    }

    public getScene() {
        return this.scene;
    }
}